import { Trans } from '@kc-console/core';

import { Typography } from '../Typography';

import type { HighlightTransProps } from './types';

/**
 * component for highlight text
 * @description
 * highlight text is a text that is highlighted in the text.
 * it is used to highlight a specific part of the text.
 * @param props HighlightTransProps
 * @returns React.ReactNode
 */
const HighlightTrans = (props: HighlightTransProps) => {
  const {
    color = 'text/default',
    variant = 'label/semibold/md',
    componentKey = 'strong',
    components,
    ...rest
  } = props;

  return (
    <Trans
      {...rest}
      components={{
        ...components,
        [componentKey]: <Typography variant={variant} color={color} />,
      }}
    />
  );
};

export default HighlightTrans;
